export const KALGUDI_HOME_STREAM_EVENTS = {
  SHARE_UPDATE: 'Share a Thought',
  QUESTION: 'question',
  PROFILE_VISITED: 'PROFILE_VISITED',
  CONNECT_REQUEST_ACCEPTED: 'CONNECT_REQUEST_ACCEPTED',
  SURVEYS: 'SURVEYS',
  TRAINING: 'Training'
};
